import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, apiErr } from "@/lib/api";
import { Button, Input, Label } from "@/components/kit";
import { KeyRound, LogOut, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForcePasswordChange() {
  const { user, refreshUser, logout } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Lösenordet måste vara minst 6 tecken");
    if (pw !== pw2) return toast.error("Lösenorden matchar inte");
    setBusy(true);
    try {
      await api.post("/auth/change-password", { new_password: pw });
      toast.success("Lösenord uppdaterat");
      await refreshUser();
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <div className="w-full max-w-md rise">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500 text-slate-950"><ShieldCheck size={24} /></div>
          <div>
            <div className="font-display text-lg font-bold text-white">Välj ett nytt lösenord</div>
            <div className="text-xs uppercase tracking-widest text-amber-500">Första inloggningen</div>
          </div>
        </div>
        <div className="rounded-2xl border border-slate-800 bg-slate-900/70 p-7">
          <p className="mb-5 text-sm text-slate-400">Hej {user?.name?.split(" ")[0]}! Av säkerhetsskäl behöver du byta det tillfälliga lösenordet innan du fortsätter.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label>Nytt lösenord</Label>
              <Input data-testid="new-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder="Minst 6 tecken" required />
            </div>
            <div>
              <Label>Bekräfta lösenord</Label>
              <Input data-testid="confirm-password-input" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Skriv igen" required />
            </div>
            <Button data-testid="save-new-password-button" type="submit" disabled={busy} className="w-full">
              <KeyRound size={16} /> {busy ? "Sparar…" : "Spara och fortsätt"}
            </Button>
          </form>
          <button data-testid="force-logout-button" onClick={logout} className="mt-4 inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-300">
            <LogOut size={13} /> Logga ut
          </button>
        </div>
      </div>
    </div>
  );
}
